import { ExpandedList10Icon } from './ExpandedList10Icon';
import { ExpandedList11Icon } from './ExpandedList11Icon';
import { ExpandedList12Icon } from './ExpandedList12Icon';
import { ExpandedList1Icon } from './ExpandedList1Icon';
import { ExpandedList2Icon } from './ExpandedList2Icon';
import { ExpandedList3Icon } from './ExpandedList3Icon';
import { ExpandedList4Icon } from './ExpandedList4Icon';
import { ExpandedList5Icon } from './ExpandedList5Icon';
import { ExpandedList6Icon } from './ExpandedList6Icon';
import { ExpandedList7Icon } from './ExpandedList7Icon';
import { ExpandedList8Icon } from './ExpandedList8Icon';
import { ExpandedList9Icon } from './ExpandedList9Icon';

export const expandedListIcons = [
  ExpandedList1Icon,
  ExpandedList2Icon,
  ExpandedList3Icon,
  ExpandedList4Icon,
  ExpandedList5Icon,
  ExpandedList6Icon,
  ExpandedList7Icon,
  ExpandedList8Icon,
  ExpandedList9Icon,
  ExpandedList10Icon,
  ExpandedList11Icon,
  ExpandedList12Icon,
];
